<div class="border border-base-300 rounded-xl overflow-hidden divide-y divide-base-300 bg-base-100">
  @for (item of options; track item.title; let i = $index) {
    <div
      class="flex items-center p-4 gap-4 cursor-pointer transition-colors duration-150"
      [class.bg-primary/5]="selectedIndex === i"
      [class.hover:bg-base-200/50]="selectedIndex !== i"
      (click)="updateSelectedIndex(i)"
    >
      <div class="text-primary text-xl flex items-center justify-center pl-2 flex-shrink-0">
        @if (selectedIndex === i) {
          <i class="fa-solid fa-circle-check"></i>
        } @else {
          <i class="fa-regular fa-circle text-base-content/40"></i>
        }
      </div>
      <div class="flex-1 min-w-0">
        <div class="flex items-center justify-between gap-2">
          <div class="flex items-center gap-2 flex-wrap">
            <h5 class="font-semibold text-base text-base-content m-0">{{ item.title }}</h5>
            @if (item.badge) {
              <span class="daisy-badge daisy-badge-sm daisy-badge-primary">{{ item.badge }}</span>
            }
          </div>
          @if (item.price != null) {
            <span class="font-bold text-sm text-primary flex-shrink-0">{{ item.price }}</span>
          }
        </div>
        <p class="text-sm text-base-content/70 m-0 mt-0.5">{{ item.subtitle }}</p>
      </div>
    </div>
  }
</div>
